import { InfoOutlined as InfoIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ResumeWarning = () => {
	const { t } = useTranslation(['resume']);
	const warningText = t('unparsed_resume.untrustedLinkWarning');
	return (
		<Box
			display="flex"
			flexWrap="nowrap"
			gap={1}
			padding={1}
			alignItems="center"
			borderBottom={1}
			borderColor="divider"
		>
			<InfoIcon fontSize="medium" color="text.secondary" />
			<Typography aria-label={warningText} variant="caption">
				{warningText}
			</Typography>
		</Box>
	);
};

export default ResumeWarning;
